// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

import '@tailwindplus/elements';
import "trix"
import "@rails/actiontext"
import "./services/worker"
import Pagy from "./pagy.mjs"

import Alpine from "alpinejs"
window.Alpine = Alpine
Alpine.start()
import "./channels"

document.addEventListener("turbo:before-fetch-request", (event) => {
    // Check if this is a Turbo Stream request by examining the Accept header
    if (event.detail.fetchOptions?.headers["Accept"]?.includes("text/vnd.turbo-stream.html")) {
        // Create a style observer that will immediately hide any progress bar for turbo stream requests
        const observer = new MutationObserver((mutations) => {
            mutations.forEach(() => {
                const progressBar = document.querySelector('.turbo-progress-bar');
                if (progressBar) {
                    progressBar.style.display = 'none';
                }
            });
        });

        // Observe the body for when the progress bar gets added
        observer.observe(document.body, {childList: true, subtree: true});

        // Disconnect the observer after the request is complete
        document.addEventListener("turbo:render", () => {
            observer.disconnect();
        }, {once: true});
    }
});

document.addEventListener("turbo:frame-missing", (event) => {
    // Prevent Turbo from injecting the default "Content missing" message
    event.preventDefault();

    // Replace the frame’s innerHTML with custom content
    event.target.innerHTML = `
    <div class="p-4">
      <h3 class="text-xl font-medium">Oops—something went wrong.</h3>
      <p class="text-base">Please try again later or <a href="/">return home</a>.</p>
    </div>`;
});

window.addEventListener("turbo:load", Pagy.init)
window.addEventListener("turbo:render", Pagy.init)
window.addEventListener("turbo:frame-render", Pagy.init)